import React, { ChangeEvent, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button, Input } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import { DealerContact } from '@types';
import cls from './DealerForm.module.css';

const initialContact = {
  name: '',
  position: '',
  phone: '',
  email: '',
};

interface Props {
  record: any;
}

export const DealerContacts = ({ record }: Props) => {
  const { setValue, watch } = useFormContext();
  const contacts: DealerContact[] = watch('contacts') || [];

  useEffect(() => {
    if (!record?.id) {
      const currentValue = watch('contacts');
      if (!currentValue || currentValue.length === 0) {
        setValue('contacts', [initialContact]);
      }
      return;
    }

    if (record?.contacts && Array.isArray(record.contacts) && record.contacts.length > 0) {
      setValue('contacts', contacts);
    } else {
      setValue('contacts', []);
    }
  }, [record?.id, record?.contacts, setValue, watch]);

  const addContactsHandler = () => {
    if (hasEmptyContacts) {
      return;
    }

    const currentContacts = contacts || [];
    setValue('contacts', [...currentContacts, initialContact]);
  };

  const removeContactsHandler = (index: number) => {
    const newContacts = contacts.filter((_, i) => i !== index);
    setValue('contacts', newContacts);
  };

  const updateContactsHandler = (index: number, e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    const newContacts = [...contacts];
    newContacts[index] = { ...newContacts[index], [name]: value };
    setValue('contacts', newContacts);
  };

  const hasEmptyContacts = contacts.some(({ name }) => name === '');

  return (
    <div className={cls.crops}>
      <div className={cls.cropsTitle}>Other Contacts</div>
      <div className={cls.cropsTable}>
        <div className={cls.cropsTableHead}>
          <div className={cls.cropsTableCol}>Name</div>
          <div className={cls.cropsTableCol}>Position</div>
          <div className={cls.cropsTableCol}>Phone</div>
          <div className={cls.cropsTableCol}>Email</div>
        </div>
        <div>
          {contacts.map((contact, index) => (
            <div key={`crop-${index}`} className={cls.cropsTableRow}>
              <div className={cls.cropsTableRemove} onClick={() => removeContactsHandler(index)}>
                <MinusOutlined />
              </div>
              <Input
                className={cls.contactsTableInput}
                onChange={(e) => updateContactsHandler(index, e)}
                value={contact.name}
                name="name"
              />
              <Input
                className={cls.contactsTableInput}
                onChange={(e) => updateContactsHandler(index, e)}
                value={contact.position}
                name="position"
              />
              <Input
                className={cls.contactsTableInput}
                onChange={(e) => updateContactsHandler(index, e)}
                value={contact.phone}
                name="phone"
              />
              <Input
                className={cls.contactsTableInput}
                onChange={(e) => updateContactsHandler(index, e)}
                value={contact.email}
                name="email"
              />
            </div>
          ))}
        </div>
        <div className={cls.cropsTableActions}>
          <Button
            className={cls.cropsTableAdd}
            htmlType="button"
            onClick={addContactsHandler}
            disabled={hasEmptyContacts}
          >+</Button>
        </div>
      </div>
    </div>
  );
};
